import { Card, CardContent, CardHeader } from '@material-ui/core';

const DashboardProd = () => (
    <Card>
        <CardHeader title="Ride Modes PROD" />
        <CardContent>Click on the Ride Modes tab on the left to modify the PROD environment ride modes configuration.</CardContent>
    </Card>
);

export default DashboardProd;